import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17296b8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UsersListItem" }
const _hoisted_2 = { class: "flex items-start justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.item.status)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small mr-3", {
                        green: _ctx.item.status.id === 1,
                        red: _ctx.item.status.id === 2,
                    }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.status.name), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.item.roles && _ctx.item.roles.length)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 1,
              class: _normalizeClass(["small", { primary: Boolean(_ctx.item.roles.length) }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.roles[0] ? _ctx.item.roles[0].name : 'Нет роли'), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("p", null, "Email: " + _toDisplayString(_ctx.item.email || '-'), 1),
    _createElementVNode("p", null, "Телефон: " + _toDisplayString(_ctx.item.phone || '-'), 1),
    _createElementVNode("p", null, "Роли: " + _toDisplayString(_ctx.getRoles), 1),
    _createElementVNode("p", null, "Дата создания: " + _toDisplayString(_ctx.formatDate(_ctx.item.created_at)), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_button_dropdown, { title: "Выберите действие" }, {
        default: _withCtx(() => [
          (_ctx.item.status && _ctx.item.status.id === 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small",
                loading: _ctx.state.is_user_session_loading,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createUserSession('pvz')))
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Войти под пользователем (PVZ) ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.isGoSparkAuth && _ctx.item.status && _ctx.item.status.id === 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "primary small",
                loading: _ctx.state.is_user_session_loading,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createUserSession('gospark')))
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Войти под пользователем (gospark) ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.item.status && _ctx.item.status.id === 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 2,
                class: "primary small",
                loading: _ctx.state.is_user_session_loading,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createUserSession('bpms')))
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Войти под пользователем (BPMS) ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.item.status && _ctx.item.status.id === 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 3,
                class: "primary small",
                loading: _ctx.state.is_user_session_loading,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createUserSession('wms')))
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Войти под пользователем (WMS) ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.emitUpdate
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" Редактировать ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.emitAttach
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(" Привязать к сектору диспетчера ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.item.status && _ctx.item.status.id === 1)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 4,
                class: "red text small",
                loading: _ctx.state.is_status_loading,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeStatus(2)))
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createTextVNode(" Деактивировать ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.item.status && _ctx.item.status.id === 2)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 5,
                class: "green text small",
                loading: _ctx.state.is_status_loading,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeStatus(1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(" Активировать ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_the_button, {
            class: "red small text",
            onClick: _ctx.emitDelete
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createTextVNode(" Удалить ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
}